import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';
import { AppConfig } from '../../core/config-models/app-config.model';
import { APP_CONFIG } from '../../config/app-config.module';
import { SharedService } from '../../shared/shared.service';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css']
})
export class LandingComponent implements OnInit, OnDestroy {
  subdomain: string;
  logoLoaded: boolean = false;
  backgroundImageLoaded: boolean = false;
  private preloadedImages: Set<string> = new Set();

  constructor(
    private router: Router,
    private sharedService: SharedService,
    @Inject(APP_CONFIG) private appConfig: AppConfig
  ) {
    this.subdomain = this.sharedService.getSubDomain();
  }

  footprints: AnimationOptions = {
    path: '../assets/Lottie/footprints.json'
  };
  paperPlane: AnimationOptions = {
    path: '../assets/Lottie/paper-plane.json'
  };
  phone: AnimationOptions = {
    path: '../assets/Lottie/phone.json'
  };

  ngOnInit(): void {
    // Preload critical images
    this.preloadImages();
  }

  ngOnDestroy(): void {
    // Clean up any ongoing image loading
    this.preloadedImages.clear();
  }

  private preloadImages(): void {
    // Preload logo
    const logoPath = `assets/Hayrick/logo/${this.subdomain}/logo-dark.svg`;
    this.preloadImage(logoPath, () => {
      this.logoLoaded = true;
    });

    // Preload background image
    const backgroundPath = 'assets/Hayrick/landing.png';
    this.preloadImage(backgroundPath, () => {
      this.backgroundImageLoaded = true;
    });
  }

  private preloadImage(src: string, onLoad?: () => void): void {
    if (this.preloadedImages.has(src)) {
      onLoad?.();
      return;
    }

    const img = new Image();
    img.onload = () => {
      this.preloadedImages.add(src);
      onLoad?.();
    };
    img.onerror = () => {
      console.warn(`Failed to load image: ${src}`);
      onLoad?.(); // Still call onLoad to prevent blocking
    };
    img.src = src;
  }

  clickToNav() {
    this.router.navigateByUrl('auth/sign-up');
  }

  animationCreated(animationItem: AnimationItem): void {
  }
}
